import { Card as AntdCard } from "antd";
import styled from "styled-components";
export const Card = styled(AntdCard)`
  border-radius: ${(props) => props.theme.border.radius};
`;
